import React, { useEffect, useState } from 'react'

const SearchDropdown = ({
  data,
  placeholder,
  onSelect,
  maxResults = 30,
  formData,
  value
}) => {
  const [searchTerm, setSearchTerm] = useState('')
  const [filteredData, setFilteredData] = useState([])
  const [isDropdownVisible, setIsDropdownVisible] = useState(false) // Track dropdown visibility

  const handleSearch = event => {
    const term = event.target.value
    setSearchTerm(term)

    const filtered = data
      .filter(item => item.name.toLowerCase().includes(term.toLowerCase()))
      .slice(0, maxResults)

    setFilteredData(filtered)
    setIsDropdownVisible(true)
  }

  const handleSelect = name => {
    setSearchTerm(name)
    setFilteredData([])
    setIsDropdownVisible(false)
    onSelect(name)
  }

  const handleInputFocus = () => {
    if (filteredData.length > 0) {
      setIsDropdownVisible(true)
    }
  }

  const handleBlur = () => {
    // Hide dropdown when clicking outside the input after a slight delay
    setTimeout(() => {
      setIsDropdownVisible(false)
    }, 150)
  }

  useEffect(() => {
    setSearchTerm(value)
  }, [value])
  return (
    <div>
      <input
        type='text'
        className='autocomplete-airport inp-text'
        id='search-user'
        value={searchTerm}
        onChange={handleSearch}
        onFocus={handleInputFocus}
        onBlur={handleBlur}
        required
      />

      {isDropdownVisible && (
        <div className='select-source new-search'>
          <ul className='border rounded p-2 max-h-60 overflow-y-auto'>
            {filteredData.length > 0 ? (
              filteredData.map((item, index) => (
                <li
                  key={index}
                  onClick={() => handleSelect(item.name)}
                  className='p-2 hover:bg-gray-100 cursor-pointer'
                >
                  {item.name} {item.type && item.type}
                </li>
              ))
            ) : (
              <li
                className='p-2 text-gray-500 text-center '
                style={{ marginTop: '15px', marginBottom: '0px' }}
              >
                No data found
              </li>
            )}
          </ul>
        </div>
      )}
    </div>
  )
}

export default SearchDropdown
